import { css } from 'styled-components'

export const roleCellStyle = css`
	display: flex;
	height: 100%;
	justify-content: flex-start;
	align-items: center;
	flex-direction: row;
	gap: 5px;
`

export const roleCellItemStyle = css`
	background-color: #e6e6e6;
	padding: 4px 10px;
	color: #7e7e80;
	font-size: 12px;
	font-style: normal;
	font-weight: 600;
	text-transform: uppercase;
	border-radius: 16px;
`
